export default "__VITE_ASSET__Bzc4VWQ0__"